import { render, staticRenderFns } from "./ProductDescriptionsCompare.vue?vue&type=template&id=55e2a4d3&scoped=true"
import script from "./ProductDescriptionsCompare.vue?vue&type=script&lang=js"
export * from "./ProductDescriptionsCompare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e2a4d3",
  null
  
)

export default component.exports